import React, { Component, Fragment } from "react";
import styled, { css } from "styled-components";
import { IconButton, Icon, Tooltip } from "@material-ui/core";
import getUserProfile from "js/core/services/userProfiles";
import { Thumbnail } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid";
import moment from "moment";
import { renderPresentationContextMenu } from "js/editor/PresentationLibrary/PresentationContextMenu";
import { themeColors } from "js/react/sharedStyles";
import { $, _ } from "js/vendor";
import { ContextMenu, IconMenu } from "js/react/components/UiComponents";
import { PresentationFilterContext } from "./PresentationFilterContext";
import Avatar from "js/react/components/Avatar";
import { app } from "js/namespaces";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { ShareDialog } from "js/react/views/PresentationSettings/dialogs/ShareDialog";
import LoadableAsync from "js/react/components/LoadableAsync";

const LibraryList = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 80px 1fr 100px 100px 60px 160px 40px;
  grid-gap: 20px;
  justify-content: flex-start;
  align-items: center;
`;

const LibraryListHeader = styled(LibraryList)`
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  text-transform: uppercase;
`;

const LibraryListContainer = styled.div`
    border-top: 2px solid #f5f5f9;
    height: 100%;

    .dark-mode & {
        border-top: 2px solid #222;
    }
`;

const LibraryListItem = styled(LibraryList)`
  background: ${props => props.selected ? themeColors.lightBlue : "white"};
  border-bottom: 2px solid #f5f5f9;
  padding: 10px 10px;
  letter-spacing: 0px;
  ${({ readOnly = false }) => !readOnly && css`
    &:hover {
        background: ${props => props.selected ? themeColors.lightBlue : themeColors.hoverBlue};
    }`}
  .thumbnail {
    width: 80px;
    height: 45px;
    img {
      height: 100%;
      outline: solid 1px #ddd;
    }
  }
  .title {
    font-weight: 600;
  }
  .col {
    display: flex;
    align-items: center;
  }
  .avatar {
    width: 25px;
    height: 25px;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .dark-mode & {
    background: ${props => props.selected ? "#444" : "#333"};
    border-bottom: 2px solid #222;

    ${({ readOnly = false }) => !readOnly && css`
    &:hover {
        background: ${props => props.selected ? "#444" : "#555"};
    }`}
  }
`;

export class PresentationLibraryList extends Component {
    static contextType = PresentationFilterContext;

    state = {
        selection: []
    }

    constructor() {
        super();

        this.listRef = React.createRef();
    }

    handleMouseDownOnItem = (item, event) => {
        if (this.props.readOnly) return;

        let { items } = this.props;

        event.stopPropagation();
        let selection = this.state.selection;
        if (event.metaKey || event.ctrlKey) {
            if (selection.contains(item)) {
                selection.remove(item);
            } else {
                selection.push(item);
            }
        } else if (event.shiftKey) {
            let startIndex = this.startSelectionIndex || 0;
            let endIndex = items.indexOf(item);

            if (endIndex > startIndex) {
                for (let i = startIndex + 1; i <= endIndex; i++) {
                    let item = items[i];
                    if (!selection.contains(item)) {
                        selection.push(item);
                    }
                }
            } else {
                for (let i = startIndex; i >= endIndex; i--) {
                    let item = items[i];
                    if (!selection.contains(item)) {
                        selection.push(item);
                    }
                }
            }
        } else {
            if (!selection.contains(item)) {
                selection = [item];
                this.startSelectionIndex = items.indexOf(item);
            }
            this.dragItems(event, item, selection);
        }
        this.setState({ selection: selection });
    }

    handleMouseUpOnItem = (item, event) => {
        this.props.onSelectedPresentation && this.props.onSelectedPresentation([item]);

        if (this.props.readOnly) return;

        event.preventDefault();
        if (event.shiftKey || event.metaKey || event.ctrlKey) return;

        this.setState({ selection: [item] });
    }

    dragItems(event, mousedItem, selection) {
        let startX = event.pageX;
        let startY = event.pageY;

        let $dragSelection;
        let startDrag = () => {
            $dragSelection = $("body").addEl($.div("dragged-items"));
            $dragSelection.css({
                position: "absolute",
                zIndex: 1000,
                width: 133,
                height: 77,
                pointerEvents: "none",
                boxShadow: "10px 10px 20px rgba(0,0,0,.4)"
            });

            for (let item of selection) {
                let $el = $(this.listRef.current).find(`[data-item-id=${item.id}]`);
                if ($el.length) {
                    let $image = $el.find(".thumbnail img").clone();
                    $image.css({ position: "absolute", border: "solid 1px #333", pointerEvents: "none" });
                    $image.width(133).left(0).top(0);
                    if (item != mousedItem) {
                        $image.css({ transform: `rotate(${Math.random() * 20 - 10}deg)` });
                        $dragSelection.prepend($image);
                    } else {
                        $dragSelection.append($image);
                    }
                }
            }

            this.props.onStartDragItems && this.props.onStartDragItems(selection);
        };

        $(document).on("mousemove.drag", event => {
            if (!$dragSelection && (Math.abs(event.pageX - startX) > 5 || Math.abs(event.pageY - startY) > 5)) {
                startDrag();
            } else if ($dragSelection) {
                $dragSelection.left(event.pageX).top(event.pageY);
            }
        });

        $(document).on("mouseup.drag", event => {
            $(document).off(".drag");

            if ($dragSelection) {
                $dragSelection.remove();

                _.defer(() => {
                    // defer this so the drop on the folder happens before we turn off isDraggingItems state
                    this.props.onDropDragItems && this.props.onDropDragItems(selection, event);
                });
            }
        });
    }

    handleContextMenu = event => {
        if (this.props.readOnly) return;

        event.preventDefault();
        this.setState({ showContextMenu: true, contextMenuX: event.pageX, contextMenuY: event.pageY });
    }

    handleCloseContextMenu = () => {
        this.setState({ showContextMenu: false });
    }

    async loadPermission(selection) {
        if (selection.length === 1) {
            let item = selection[0];
            await item?.presentationModel?.getUserPermissions(true);
        } else {
            return;
        }
    }

    render() {
        let { items, sort, onSort, readOnly, onDoubleClick, showHeader = !app.isConstrained } = this.props;
        let { selection, showContextMenu, contextMenuX, contextMenuY } = this.state;

        return (
            <div className="library-list" ref={this.listRef}>
                {showHeader &&
                    <LibraryListHeader>
                        <ColumnHeader label="Presentation"
                            field="name"
                            sort={sort}
                            onSort={onSort} />
                        <div></div>
                        <ColumnHeader label="Created"
                            field="createdAt"
                            sort={sort}
                            onSort={onSort} />
                        <ColumnHeader label="Updated"
                            field="modifiedAt"
                            sort={sort}
                            onSort={onSort} />
                        <ColumnHeader label="Slides"
                            field="slideCount"
                            sort={sort}
                            onSort={onSort} />
                        <ColumnHeader label="Owner"
                            field="ownerName"
                            sort={sort}
                            onSort={onSort} />
                    </LibraryListHeader>
                }
                <LibraryListContainer>
                    {items.map(presentation => (
                        <PresentationLibraryListItem key={presentation.id}
                            item={presentation}
                            readOnly={readOnly}
                            selected={selection.contains(presentation)}
                            onMouseDown={event => this.handleMouseDownOnItem(presentation, event)}
                            onMouseUp={event => this.handleMouseUpOnItem(presentation, event)}
                            onDoubleClick={onDoubleClick}
                            onContextMenu={this.handleContextMenu}
                        />
                    ))}
                </LibraryListContainer>
                {
                    showContextMenu &&
                    <LoadableAsync
                        load={() => this.loadPermission(selection)}
                        renderChildren={() => (
                            <ContextMenu x={contextMenuX}
                                y={contextMenuY}
                                onClose={this.handleCloseContextMenu}
                            >
                                {renderPresentationContextMenu(selection, this.context)}
                            </ContextMenu>
                        )}
                    />
                }
            </div>
        );
    }
}

const ColumnHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  .MuiIcon-root {
    font-size: 14px;
    margin-left: 10px;
    color: #666;
  }
`;

class ColumnHeader extends Component {
    handleClick = event => {
        let { field, sort } = this.props;
        this.props.onSort({ field, reverse: !sort.reverse });
    }

    render() {
        let { label, field, sort } = this.props;

        return (
            <ColumnHeaderDiv onClick={this.handleClick}>
                {label}
                {sort.field == field && sort.reverse && <Icon>arrow_upward</Icon>}
                {sort.field == field && !sort.reverse && <Icon>arrow_downward</Icon>}
            </ColumnHeaderDiv>
        );
    }
}

class PresentationLibraryListItem extends Component {
    _isMounted = false;
    static contextType = PresentationFilterContext;

    state = {
        url: "",
        ownerName: "",
        avatarUrl: ""
    }

    constructor() {
        super();

        this.ref = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        this.observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting === true) {
                if (_.isEmpty(this.state.url)) {
                    this.fetchImages();
                }
            }
        });

        this.observer.observe(this.ref.current);
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.observer.disconnect();
    }

    async fetchImages() {
        if (!this._isMounted) {
            return;
        }

        let url;

        if (this.props.item.presentationModel) {
            url = await this.props.item.presentationModel.getThumbnailUrl();
        } else {
            url = await this.props.item.getThumbnailUrl();
        }

        this.setState({ url });

        getUserProfile(this.props.item.userId).then(results => {
            this.setState({
                ownerName: results.displayName || results.email || "",
                avatarUrl: results.photoURL || ""
            });
        });
    }

    handleSharePresentation = selectedPresentation => {
        ShowDialog(ShareDialog, { presentation: selectedPresentation.presentationModel });
    }

    async loadPermission(selection) {
        if (selection.length === 1) {
            let item = selection[0];
            await item?.presentationModel?.getUserPermissions(true);
        } else {
            return;
        }
    }

    render() {
        let { item, readOnly, onMouseDown, onMouseUp, onContextMenu, selected, onDoubleClick } = this.props;
        let { url, ownerName, avatarUrl } = this.state;

        return (
            <LibraryListItem
                className="library-list-item"
                data-item-id={item.id}
                selected={selected}
                onMouseDown={onMouseDown}
                onMouseUp={onMouseUp}
                onDoubleClick={() => onDoubleClick && onDoubleClick(item)}
                onContextMenu={onContextMenu}
                ref={this.ref}
                readOnly={readOnly}
            >
                <PresentationLibraryListItemThumbnail readOnly={readOnly} url={url} />
                <div className="title">{item.name}</div>
                {
                    !app.isConstrained &&
                    <Fragment>
                        <div className="col">{moment(item.createdAt).format("MMM D YYYY")}</div>
                        <div className="col">{moment(item.modifiedAt).format("MMM D YYYY")}</div>
                        <div className="col">{item.slideCount}</div>
                        <Tooltip title={ownerName}>
                            <div className="col"><Avatar url={avatarUrl} />{`${ownerName.substr(0, 20)}...`}</div>
                        </Tooltip>
                        {
                            !readOnly &&
                            <IconMenu>
                                <LoadableAsync
                                    load={() => this.loadPermission([item])}
                                    renderChildren={() =>
                                        renderPresentationContextMenu([item], this.context)
                                    }
                                />
                            </IconMenu>
                        }
                    </Fragment>
                }
                {
                    app.isMobileOrTablet &&
                    !readOnly &&
                    !item.readOnly &&
                    <Fragment>
                        <IconButton
                            className="text-blue"
                            onMouseDown={event => {
                                event.preventDefault();
                                event.stopPropagation();
                            }}
                            onMouseUp={event => {
                                event.preventDefault();
                                event.stopPropagation();
                            }}
                            onDoubleClick={event => {
                                event.preventDefault();
                                event.stopPropagation();
                            }}
                            onClick={event => {
                                event.preventDefault();
                                event.stopPropagation();
                                this.handleSharePresentation(item);
                            }}
                        >
                            <Icon>share</Icon>
                        </IconButton>
                    </Fragment>
                }
            </LibraryListItem>
        );
    }
}

class PresentationLibraryListItemThumbnail extends Thumbnail {
    state = {
        isLoaded: false,
        isVisible: false
    }

    componentDidMount() {
        this.observer = new IntersectionObserver(entries => {
            this.setState({ isVisible: entries[0].isIntersecting === true });
        });

        this.observer.observe(this.ref.current);
    }

    componentWillUnmount() {
        this.observer.disconnect();
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.props.url !== prevProps.url || this.state.isVisible !== prevState.isVisible) && (this.state.isLoaded || this.state.isVisible)) {
            this.setState({ isLoaded: false });
            this.loadImage();
        }
    }
}
